import React from 'react';
import {Switch, FormControlLabel, Divider} from "@material-ui/core";
import RenderIf from "app/components/RenderIf";

export default function Layout({children, filter, show, onHide}) {

    return (
        <div className="row bg-white rounded">
            <RenderIf condition={filter}>
                <div className="col-12 d-flex flex-row align-items-start py-4">
                    <FormControlLabel
                        control={
                            <Switch
                                checked={show}
                                onChange={onHide}
                                color="secondary"
                            />
                        }
                        label="Filter"
                        className="ml-auto mb-0"
                    />
                </div>
                <Divider className="w-100"/>
            </RenderIf>
            {children}
        </div>
    )
}